import React from "react";
import { BoxProps, Flex, HStack, Text } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ITopTraderMarketReactions } from "src/api/server/news.types";
import { WfLinkGhost } from "src/components/base/wf-link";
import { IconWikifolio } from "src/components/icons";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";
import { ReactionsCount } from "./reactions-count";

interface ITopTraderMarketReactionPreviewProps extends BoxProps {
    topTraderMarketReactions: ITopTraderMarketReactions[];
    totalResults: number;
}

const TOP_TRADER_MARKET_REACTION_PREVIEW_TEST_ID = "top-trader-market-reaction-preview";

export const TopTraderMarketReactionPreview = ({ topTraderMarketReactions, totalResults, ...boxProps }: ITopTraderMarketReactionPreviewProps) => {
    const { formatPerformance } = useNumberFormatter();

    const { t } = useTranslation("news");

    return (
        <Flex {...boxProps} gap={0.5} alignItems="center" flexWrap="wrap" w="100%" data-test-id={TOP_TRADER_MARKET_REACTION_PREVIEW_TEST_ID}>
            {topTraderMarketReactions.map((reaction, index) => {
                const valueDisplay = formatPerformance(reaction.performanceSinceCreation, 1);

                return (
                    <React.Fragment key={reaction.wikifolioId}>
                        <WfLinkGhost flexShrink={0} href={reaction.url} fontWeight="bold" fontSize="md" noOfLines={1} wordBreak="break-all">
                            {reaction.traderName}
                        </WfLinkGhost>
                        <HStack flexShrink={0} backgroundColor="green.50" borderRadius="16px" gap={0.5} px={0.5}>
                            <IconWikifolio color="green.500" boxSize={2} />
                            <Text fontSize="sm">{valueDisplay}</Text>
                        </HStack>
                        <ReactionsCount index={index} totalResults={totalResults} t={t} />
                    </React.Fragment>
                );
            })}
        </Flex>
    );
};
